// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BackButton_button__g5ElV{
    cursor: pointer;
    text-align: center;
    font-size: 23px;
    display: flex;
    justify-content: center;
    align-items: center;
    color:white;
    width:39px;
    height:39px;
    border-radius: 10px;



}`, "",{"version":3,"sources":["webpack://./src/components/UI/BackButton/BackButton.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,UAAU;IACV,WAAW;IACX,mBAAmB;;;;AAIvB","sourcesContent":[".button{\n    cursor: pointer;\n    text-align: center;\n    font-size: 23px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color:white;\n    width:39px;\n    height:39px;\n    border-radius: 10px;\n\n\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `BackButton_button__g5ElV`
};
export default ___CSS_LOADER_EXPORT___;
